let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eZpCG")).then(() => parcelRequire('bDruS'));